import { createSelector } from '@reduxjs/toolkit';
import { ProjectParameters } from 'ducks/types/store-types';
import { RootState } from 'store';

const jobDefinitionParametersSlice = (state: RootState) => state.job_definition_parameters;

export const selectJobDefinitionParameters = createSelector(
  [jobDefinitionParametersSlice],
  (state): ProjectParameters => state,
);

export const selectJobDefinitionInputParameters = createSelector(
  [jobDefinitionParametersSlice],
  (state): ProjectParameters => state.filter((row) => row.parameter_direction_id === 1),
);

export const selectJobDefinitionOutputParameters = createSelector(
  [jobDefinitionParametersSlice],
  (state): ProjectParameters => state.filter((row) => row.parameter_direction_id === 2),
);
